import { View } from "@react-pdf/renderer";
import {
  ResumePDFIcon,
  type IconType,
} from "components/Resume/ResumePDF/common/ResumePDFIcon";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import {
  ResumePDFLink,
  ResumePDFSection,
  ResumePDFText,
} from "components/Resume/ResumePDF/common";
import type { ResumeProfile } from "lib/redux/types";
import { extractUsernameFromURL } from "lib/utils/urlHelpers";

export const Profile = ({
  profile,
  themeColor,
  isPDF,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  profile: ResumeProfile;
  themeColor: string;
  isPDF: boolean;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  const { name, email, phone, url1, url2, summary, location } = profile;
  const iconProps = { email, phone, location, url1, url2 };
  const isOverflow = name.length > 20;
  return (
    <ResumePDFSection style={{ marginTop: spacing["4"] }}>
      <View
      style={{
        display:'flex',
        flexDirection: isOverflow ? "column" : "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <ResumePDFText
        bold={true}
        themeColor="black"
        style={{
          fontSize: "33pt",
          textAlign: "center",
        }}
      >
        {name}
      </ResumePDFText>
    </View>
     
    </ResumePDFSection>
  );
};
